import { render, staticRenderFns } from "./Activate2FA.vue?vue&type=template&id=5c1c3f57"
import script from "./Activate2FA.vue?vue&type=script&lang=js"
export * from "./Activate2FA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports